import * as React from 'react'

import { Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

const ArchivedTooltip = () => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt
      attachment="top center"
      targetAttachment="bottom center"
      open={open}
      toggle={toggle}
      label={i18n.t('shift_management.work_area_archived')}
    >
      <Icon.Medium icon="archive" />
    </Tooltip.Alt>
  )
}

export default observer(ArchivedTooltip)
